import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Instagram } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-950 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_aerospace-cnc/artifacts/ov2vy98z_Image_202601131834.jpeg"
              alt="Aether Machining"
              className="h-28 w-auto !mb-[16px] !ml-[25px] !mr-[0px] !rounded-[25px] !shadow-md"
              style={{ mixBlendMode: 'screen', filter: 'brightness(1.3) contrast(1.2)' }} />
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-red-500 transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-red-500 transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-red-500 transition-colors duration-200">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/quality" className="text-gray-400 hover:text-red-500 transition-colors duration-200">
                  Quality & Certifications
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-red-500 transition-colors duration-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services/cnc-milling" className="text-gray-400 hover:text-red-500 transition-colors duration-200">
                  CNC Milling
                </Link>
              </li>
              <li>
                <Link to="/services/cnc-turning" className="text-gray-400 hover:text-red-500 transition-colors duration-200">
                  CNC Turning
                </Link>
              </li>
              <li>
                <Link to="/services/aerospace-machining" className="text-gray-400 hover:text-red-500 transition-colors duration-200">
                  Aerospace Machining
                </Link>
              </li>
              <li>
                <Link to="/services/prototype-machining" className="text-gray-400 hover:text-red-500 transition-colors duration-200">
                  Prototype & Short-Run
                </Link>
              </li>
              <li>
                <Link to="/services/production-machining" className="text-gray-400 hover:text-red-500 transition-colors duration-200">
                  Production Machining
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="flex items-center space-x-2 text-gray-400 hover:text-red-500 transition-colors duration-200">

                  <Phone className="h-4 w-4 text-red-500" />
                  <span>{companyInfo.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center space-x-2 text-gray-400 hover:text-red-500 transition-colors duration-200">

                  <Mail className="h-4 w-4 text-red-500" />
                  <span>{companyInfo.email}</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/aethermachining"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-gray-400 hover:text-red-500 transition-colors duration-200">

                  <Instagram className="h-4 w-4 text-red-500" />
                  <span>@aethermachining</span>
                </a>
              </li>
            </ul>
            <div className="mt-6">
              <Link to="/contact">
                <button className="w-full bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md font-semibold transition-all duration-300">
                  Request a Quote
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-red-500 text-sm transition-colors duration-200">
                Privacy Policy
              </Link>
              <a
                href="https://customer-assets.emergentagent.com/job_9da7d936-407f-407d-bfab-38e56ddbdb73/artifacts/bltmf4l7_F-52_Aether_Machining_PO_Terms_and_Conditions.pdf"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-terms-link"
                className="text-gray-400 hover:text-red-500 text-sm transition-colors duration-200">
                Terms & Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;